import '@patron/patron-css/patron/index.css'
import React, { useState, useEffect } from "react"
import { Button } from "@patron/patron-react/button"
import { Paragraph } from "@patron/patron-react/paragraph"
import { TextInput } from "@patron/patron-react/textinput"
import { Label } from "@patron/patron-react/label"
import { Password } from "@patron/patron-react/password"
import { Notification } from "@patron/patron-react/notification"
import { useTranslation } from 'react-i18next'
import { Link, useHistory, useLocation } from "react-router-dom"

import "./AppleUserEnroll.scss"
import CompanyHeader from "../../companyheader/CompanyHeader"
import * as ServerConstants from '../../constants/ServerConstants'
import * as Constant from '../../constants/Constants'
import * as rebrandingUtil from '../../util/RebrandingUtility'
import base64 from 'react-native-base64'
import Spinner from '../../spinner/Spinner'

function AppleUserEnroll() {

    const { t } = useTranslation()
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [showError, setShowError] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [showUserWar, setShowUserWar] = useState(false)
    const [disableEnrollButton, setDisableEnrollButton] = useState(false)
    const [managedAppleID, setManagedAppleID] = useState("")
    const [validAppleIDEmail, setValidAppleIDEmail] = useState(false)

    const history = useHistory()
    const [showSpinner, setShowSpinner] = useState(false)

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    const query = useQuery()

    useEffect(() => {
        rebrandingUtil.setBrowserTab()
        checkForUserIdentifier()
    }, [query])

    const checkForUserIdentifier = () => {
        const managedID = query.get('user-identifier')
        if (managedID) {
            query.delete('user-identifier')
            history.replace({
                search: query.toString(),
            })
            setManagedAppleID(managedID)
            setShowError(false)
        }
        if (!managedID && !managedAppleID) {
            setShowError(true)
            setErrorMsg(t('appleManagedIDNotPresent'))
        }
    }

    const enroll = () => {
        setDisableEnrollButton(true)
        setNotificationsFalse()
        login()
    }

    function setNotificationsFalse() {
        setShowUserWar(false)
        setShowError(false)
        setValidAppleIDEmail(false)
    }

    function login() {
        setShowSpinner(true)
        fetch(window.location.origin + ServerConstants.MDM_LOGIN + "?t=" + (new Date().getTime()), {
            method: "GET",
            headers: {
                [Constant.AUTH_HEADER]: Constant.AUTH_TYPE + base64.encode(userName + ":" + password)
            }
        })
            .then((response) => {
                setShowSpinner(false)
                setDisableEnrollButton(false)
                if (!response.ok) {
                    setShowError(true)
                    setErrorMsg(t('unableToLogin'))
                    return false
                }
                else return response
            })
            .then(response => {
                if (response) {
                    enrollDevice()
                }
            })
            .catch(() => {
                setDisableEnrollButton(false)
                setShowSpinner(false)
                setShowError(true)
                setErrorMsg(t('unableToLogin'))
            })
    }

    function enrollDevice() {
        setShowSpinner(true)
        setDisableEnrollButton(true)
        const encodedUsername = encodeURIComponent(userName)
        const encodedManagedConfigId = encodeURIComponent(managedAppleID)

        const apiUrl = `${window.location.origin}${ServerConstants.APPLE_BYOD_ENROLL}?userName=${encodedUsername}&managedConfigId=${encodedManagedConfigId}`;

        fetch(apiUrl, {
            method: "POST"
        })
            .then((response) => {
                setShowSpinner(false)
                setDisableEnrollButton(false)
                if (!response.ok) {
                    setShowError(true)
                    setErrorMsg(t('unableToEnroll'))
                    return false
                }
                else return response.text()
            })
            .then((response) => {
                if (response) {
                    window.location = response
                }
            })
            .catch((err) => {
                setDisableEnrollButton(false)
                setShowSpinner(false)
                setShowError(true);
                setErrorMsg(t('unableToEnroll'))
            })
    }

    return (
        <React.Fragment>
            {showSpinner && <Spinner />}
            <CompanyHeader />
            <section className="hcl-container hcl-flex p-0 enroll-container" style={rebrandingUtil.rebrandingUIBackgroundStyle()} nonce='CSP_NONCE'>
                <div>
                    <div className="ldap-enroll-wrapper" style={{ background: rebrandingUtil.setBrandLogoPanelBg() }} nonce='CSP_NONCE'>
                        <div className="hcl-text-center">
                            <img
                                src={rebrandingUtil.setBrandLogo()}
                                alt="product logo"
                            />
                        </div>
                        <Notification
                            onClose={() => { setShowError(false) }}
                            title={errorMsg}
                            type="danger"
                            visible={showError}
                        />
                        <Notification
                            onClose={() => { setShowUserWar(false) }}
                            title={t('emailAddressWar') + userName + t('emailAddressWar@Missing')}
                            type="warning"
                            visible={showUserWar}
                        />
                        <Notification
                            onClose={() => { setValidAppleIDEmail(false) }}
                            title={t('notAValidManagedAppleID') + managedAppleID + "'"}
                            type="warning"
                            visible={validAppleIDEmail}
                        />
                        <form className="p-5">
                            <div className="hcl-form-group">
                                <TextInput
                                    type="text"
                                    placeholder={t('emailAddress')}
                                    id="username"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    required
                                />
                                <Label htmlFor="username">{t('emailAddress')}</Label>
                            </div>
                            <div className="hcl-form-group">
                                <Password
                                    placeholder={t('password')}
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <Label htmlFor="password">{t('password')}</Label>
                            </div>

                            <div>
                                <div className="mt-4 hcl-form-group">
                                    <Label htmlFor="managedAppleID">{t('managedAppleID')}</Label>
                                    <Label>{managedAppleID}
                                    </Label>
                                </div>

                            </div>
                            <div className="hcl-text-center mt-1">
                                <Button
                                    className="hcl-primary"
                                    style={{ background: rebrandingUtil.setButtonColor() }}
                                    disabled={password === "" || disableEnrollButton || userName === ''}
                                    onClick={enroll}
                                    nonce='CSP_NONCE'
                                >
                                    {t('enroll')}
                                </Button>
                            </div>
                            <div className='mt-1 hcl-text-center'>
                                <Link
                                    to={{ pathname: ServerConstants.NEED_HELP_ENROLL_PAGE }}
                                    target="_blank"
                                    title={t('needHelpEnrolling')}
                                    rel="noopener noreferrer"
                                >
                                    {t('needHelpEnrolling')}
                                </Link>
                            </div>
                            <Paragraph className="hcl-type-legal mt-4 hcl-text-center">
                                &copy; {rebrandingUtil.setCopyrightMessage(t)}
                            </Paragraph>
                        </form>
                    </div>
                </div>

            </section>
        </React.Fragment>
    )
}

export default AppleUserEnroll
